import React from 'react'
import HeroSection from "./HeroSection"
import TeamMembers from './TeamMembers'
import Whystand from './Whystand'

const Team = () => {
  return (
    <div>
      <HeroSection />
      <TeamMembers />
      <Whystand />
    </div>
  )
}

export default Team